import { render, staticRenderFns } from "./PointRecords.vue?vue&type=template&id=6d0d52a6&scoped=true&"
import script from "./PointRecords.vue?vue&type=script&lang=js&"
export * from "./PointRecords.vue?vue&type=script&lang=js&"
import style0 from "./PointRecords.vue?vue&type=style&index=0&id=6d0d52a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d52a6",
  null
  
)

export default component.exports